var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5971 6.77251L6.72212 1.89751C6.52712 1.70251 6.25629 1.58334 5.95837 1.58334L2.16671 1.58334C1.57087 1.58334 1.08337 2.07084 1.08337 2.66668L1.08337 6.45834C1.08337 6.75626 1.20254 7.02709 1.40296 7.22751L6.27796 12.1025C6.47296 12.2975 6.74379 12.4167 7.04171 12.4167C7.33962 12.4167 7.61046 12.2975 7.80546 12.0971L11.5971 8.30543C11.7975 8.11043 11.9167 7.83959 11.9167 7.54168C11.9167 7.24376 11.7921 6.96751 11.5971 6.77251ZM7.04171 11.3388L2.16671 6.45834L2.16671 2.66668L5.95837 2.66668V2.66126L10.8334 7.53626L7.04171 11.3388Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52087 4.83334C3.96961 4.83334 4.33337 4.46957 4.33337 4.02084C4.33337 3.57211 3.96961 3.20834 3.52087 3.20834C3.07214 3.20834 2.70837 3.57211 2.70837 4.02084C2.70837 4.46957 3.07214 4.83334 3.52087 4.83334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferWhite);
export default __webpack_public_path__ + "static/media/offerWhite.481fcd4e7d345e161778e9079bb0333c.svg";
export { ForwardRef as ReactComponent };